import {ControlledListItemType4} from '@Components/controlled-list/components/controlled-list-item-type-4';
import {useAppDispatch, useAppSelector} from '@/hooks';
import type {ListDefaultItemBaseStorage, LIST_ITEM_TYPE} from '../../list.types';
import {updateListItemSelectionState} from '../../list-reducer';

interface ListItemType4Props {
  id: string;
  listId: string;
}

export interface ListItemType4Storage extends ListDefaultItemBaseStorage {
  type: LIST_ITEM_TYPE.DEFAULT_4;
}

export function ListItemType4({...props}: ListItemType4Props) {
  const dispatch = useAppDispatch();
  const listItemData = useAppSelector((state) => {
    return state.list.listItemData.listItemsHashMap[props.id] as ListItemType4Storage;
  });

  const handleClick = () => {
    dispatch(
      updateListItemSelectionState({
        listId: props.listId,
        id: props.id,
      })
    );
    if (listItemData.onClick) {
      listItemData.onClick(props.listId, props.id);
    }
  };

  return listItemData ? (
    <ControlledListItemType4 id={listItemData.id} onClick={handleClick} className={listItemData.className} text={listItemData.text} isSelected={listItemData.isSelected} />
  ) : null;
}
